;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.TippingInvite = Model.Invite.extend({

	});

}(window, APP, Backbone, Marionette, $, _));